module.exports = __webpack_public_path__ + "img/yahoo_1.9313e1a3.png";